import { render } from "./CrInput.vue?vue&type=template&id=0ddcf072&scoped=true"
import script from "./CrInput.vue?vue&type=script&lang=js"
export * from "./CrInput.vue?vue&type=script&lang=js"

import "./CrInput.vue?vue&type=style&index=0&id=0ddcf072&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddcf072"]])

export default __exports__